import Select from "react-select";
import React, { useEffect, useState, useRef } from "react";
import Loader from "../../shared/loader/loader";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  CSVIcon,
  ApproveIcon,
  Disapprove,
} from "../../../assets/icons/index";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import { IVideo } from "../../../model/interface/video";
import Tooltip from "../../shared/common/ellipsisText";
import ManageVideo from "./manageVideo";
import Constant from "../../../utils/constant";
import DeleteModal from "../../shared/common/deleteModal";
import { getContentArea } from "../../../api/contentArea.service";
import { getVideos, deleteVideo } from "../../../api/videos.service";
import { Link, useNavigate } from "react-router";
import ExportToCSV from "../../shared/common/exportToCsv";
import { toast } from "react-toastify";
import { TagColor } from "../../../model/tagColor";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";
import { ISelectElement } from "../../../model/interface/keyValuePair";

type IInitialFilter = {
  videoId: number;
  standardId: number;
  standardName: string;
  standardCode: string;
  title: string;
  spanishTitle: string;
  videoUrl: string;
  transcript: string;
  isActive: boolean | undefined;
  contentAreaId: number;
  subjectId: number;
  domainId: number;
  gradeLevelId: string;
};
function Video() {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const navigate = useNavigate();

  const initialFilter: IInitialFilter = {
    videoId: 0,
    standardId: 0,
    standardName: "",
    standardCode: "",
    title: "",
    spanishTitle: "",
    videoUrl: "",
    transcript: "",
    isActive: undefined,
    contentAreaId: 0,
    subjectId: 0,
    domainId: 0,
    gradeLevelId: "",
  };

  const activeMultiState = [
    { label: "Active", value: true },
    { label: "Both", value: null, selected: true },
    { label: "Inactive", value: false },
  ];
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [videos, setVideos] = useState<IVideo[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [videoDelete, setVideoDelete] = useState<number>(0);
  const [showManagePopup, setShowManagePopup] = useState<boolean>(false);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("videoId");
  const [sortDir, setSortDir] = useState<string>("ASC");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [filterInput, setFilterInput] = useState<IInitialFilter>(initialFilter);
  const [filterStandardId, setFilterStandardId] = useState<number>();
  const [videoId, setVideoId] = useState<string>("");
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const childRef: any = useRef(undefined);
  const [contentAreas, setContentAreas] = useState<ISelectElement[]>([]);
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];

  async function bindContentAreas() {
    const response = await getContentArea();
    const result = response.data.data;
    const contentAreaData = result.map((item) => {
      return { label: item.name, value: item.contentAreaId };
    });
    setContentAreas(contentAreaData);
  }

  function bindVideos(isReset?, resetObj?, onFilter?) {
    setLoading(true);
    if (onFilter) setIsFilter(true);

    const video: IVideo = {
      videoId: videoId ? parseInt(videoId) : 0,
      standardId: filterInput.standardId,
      transcript: filterInput.transcript,
      spanishTranscript: "",
      videoUrl: filterInput.videoUrl,
      spanishVideoUrl: "",
      standardName: filterInput.standardName,
      standardCode: filterInput.standardCode,
      title: filterInput.title,
      spanishTitle: filterInput.spanishTitle,
      userId: 0,
      contentAreaId: filterInput.contentAreaId,
      subjectId: 0,
      domainId: 0,
      isActive: isActive,
      pageSize: onFilter ? defaultPageSize : pageSize,
      pageNumber: onFilter ? defaultPageNumber : pageNumber,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "ASC" : "DESC",
      videoTags: selectedTagIds.toString(),
      gradeLevelId: filterInput.gradeLevelId,
      gradeLevel: "",
    };
    setLoading(true);
    getVideos(isReset ? resetObj : video).then((response: any) => {
      setVideos(response.data.data);
      setLoading(false);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (isReset ? defaultPageSize : pageSize)
        )
      );
      setTotalRecords(response.data.totalRecords);
      if (onFilter) {
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();
        setIsFilter(false);
      }
      setLoading(false);
    });
  }

  const resetFilterHandler = () => {
    setLoading(true);
    setResetDropdownFlag(!resetDropdownFlag);
    setVideoId("");
    setIsActive(undefined);
    setFilterStandardId(0);

    bindVideos(true, {
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      standardId: 0,
      standardName: "",
      videoid: 0,
      videoUrl: "",
      title: "",
      isActive: undefined,
      orderbyColumn: orderByColumn,
      sortDir: sortDir,
    });
    setTimeout(() => {
      setResetDropdownFlag(false);
      setLoading(false);
    }, 1500);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    setFilterInput({
      ...initialFilter,
    });
    handleUntagged();
  };
  function handleStandardIdChange(e: any) {
    setFilterStandardId(e.target.value);
    setFilterInput({
      ...filterInput,
      standardId: e.target.value || 0,
    });
  }

  function confirmDelete(idToDelete: number) {
    if (idToDelete > 0) {
      setShowDeletePopup(true);
      setVideoDelete(idToDelete);
    }
  }

  function deleteRecord() {
    deleteVideo(videoDelete).then(() => {
      setShowDeletePopup(false);
      setVideoDelete(0);
      bindVideos();
    });
  }

  function closeDeletePopup() {
    setShowDeletePopup(false);
    setVideoDelete(0);
  }

  function handleSort(columnName) {
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
    setSortDir(sortAscending ? "DESC" : "ASC");
    setLoading(true);
    const videos: IVideo = {
      videoId: filterInput.videoId,
      standardId: filterInput.standardId,
      transcript: filterInput.transcript,
      spanishTranscript: "",
      videoUrl: filterInput.videoUrl,
      spanishVideoUrl: "",
      standardName: filterInput.standardName,
      standardCode: filterInput.standardCode,
      title: filterInput.title,
      spanishTitle: filterInput.spanishTitle,
      userId: 0,
      contentAreaId: 0,
      subjectId: 0,
      domainId: 0,
      isActive: isActive,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "DESC" : "ASC",
      videoTags: [],
      gradeLevelId: "",
      gradeLevel: "",
    };

    getVideos(videos).then((response: any) => {
      setLoading(false);
      setVideos(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
    });
  }

  function bindStandards() {
    getContentArea().then((response) => {
      const contentDataToPass = response.data.data.map((_g) => {
        return {
          label: _g.name,
          value: parseInt(_g.contentAreaId),
        };
      });
    });
  }

  const handleRedirect = (video?: IVideo) => {
    if (!video) {
      const defaultData: IVideo = {
        videoId: 0,
        standardId: 0,
        transcript: "",
        spanishTranscript: "",
        videoUrl: "",
        spanishVideoUrl: "",
        standardName: "",
        standardCode: "",
        title: "",
        spanishTitle: "",
        userId: 0,
        contentAreaId: 0,
        subjectId: 0,
        domainId: 0,
        isActive: undefined,
        videoTags: [],
        gradeLevelId: "",
        gradeLevel: "",
      };
      video = defaultData;
    }

    navigate(
      video?.videoId
        ? Constant.VIDEOEDIT.replace(":id", video.videoId.toString())
        : Constant.VIDEO,
      { state: { objectToEdit: video } }
    );
  };
  function handleFilterChange(e: any, type) {
    switch (type) {
      case "StandardName":
        setFilterInput({
          ...filterInput,
          standardName: e.target.value || "",
        });
        break;
      case "StandardId":
        setFilterInput({
          ...filterInput,
          standardId: filterStandardId || 0,
        });
        break;
      case "Title":
        setFilterInput({
          ...filterInput,
          title: e.target.value || "",
        });
        break;
      case "VideoUrl":
        setFilterInput({
          ...filterInput,
          videoUrl: e.target.value || "",
        });
        break;
      case "IsActive":
        setFilterInput({
          ...filterInput,
          isActive: e || false,
        });
        break;
      case "GradeLevel":
        setFilterInput({
          ...filterInput,
          gradeLevelId: e.map((item) => item.value).join(", ") || "",
        });
        break;
      case "ContentArea":
        setFilterInput({
          ...filterInput,
          contentAreaId: e.value || 0,
        });
        break;
    }
  }
  useEffect(() => {
    bindStandards();
    bindContentAreas();
  }, []);

  useEffect(() => {
    if (isLoaded && !isFilter) {
      bindVideos();
    }
  }, [pageNumber]);

  useEffect(() => {
    bindVideos();
  }, [selectedTagIds]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      bindVideos();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const exportFn = async () => {
    setLoading(true);
    const video: IVideo = {
      videoId: videoId ? parseInt(videoId) : 0,
      standardId: filterInput.standardId,
      transcript: filterInput.transcript,
      spanishTranscript: "",
      videoUrl: filterInput.videoUrl,
      spanishVideoUrl: "",
      standardName: filterInput.standardName,
      standardCode: filterInput.standardCode,
      title: filterInput.title,
      spanishTitle: filterInput.spanishTitle,
      userId: 0,
      contentAreaId: filterInput.contentAreaId,
      subjectId: 0,
      domainId: 0,
      isActive: isActive,
      pageSize: 9999 * 9999,
      pageNumber: 1,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "DESC" : "ASC",
      videoTags: [],
      gradeLevelId: filterInput.gradeLevelId,
      gradeLevel: "",
    };
    setLoading(true);
    const response = getVideos(video);
    const data = (await response).data;

    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "videos.csv");
    } else {
      toast.warning("No records to download");
    }
  };

  const handleFilterTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);
    setSelectedTagIds(selectedTagIds);
  };

  const handleTagClick = (tag) => {
    setSelectedTagIds([tag.tagId]);
  };

  const handleUntagged = () => {
    setSelectedTagIds([]);
  };

  return (
    <AllowedTo perform={Permissions.video_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showManagePopup && <ManageVideo />}

      {showDeletePopup && (
        <DeleteModal
          closeDeleteModal={closeDeletePopup}
          deleteRecord={deleteRecord}
        />
      )}

      <div className="flex-1">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Video</h3>
              <AllowedTo perform={Permissions.video_create}>
                <button
                  onClick={() => handleRedirect()}
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Video
                </button>
              </AllowedTo>
            </div>
            <div className="pt-6 border-b pb-6">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Video Id</label>
                  <div className="contentArea mt-1">
                    <input
                      id="videoId"
                      name="videoId"
                      value={videoId || ""}
                      onChange={(e) => setVideoId(e.target.value)}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Title</label>
                  <div className="contentArea mt-1">
                    <input
                      id="title"
                      name="title"
                      value={filterInput.title}
                      onChange={(e) => {
                        handleFilterChange(e, "Title");
                      }}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">VideoUrl</label>
                  <div className="contentArea mt-1">
                    <input
                      id="videoUrl"
                      name="videoUrl"
                      value={filterInput.videoUrl}
                      onChange={(e) => {
                        handleFilterChange(e, "VideoUrl");
                      }}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Standard Id</label>
                  <div className="contentArea mt-1">
                    <input
                      id="standardId"
                      name="standardId"
                      value={filterStandardId || ""}
                      onChange={handleStandardIdChange}
                      type="number"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Standard Name</label>
                  <div className="contentArea mt-1">
                    <input
                      id="standardName"
                      name="standardName"
                      value={filterInput.standardName}
                      onChange={(e) => {
                        handleFilterChange(e, "StandardName");
                      }}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-2 flex items-center mt-6">
                  <MultiStateButton
                    labels={activeMultiState}
                    onSelect={(e) => setIsActive(e.value)}
                    onReset={resetDropdownFlag}
                  />
                </div>
                <div className="col-span-6 sm:col-span-1 flex items-end">
                  <div className="flex items-center contentArea">
                    <TagSelector
                      label={"Tags"}
                      onTagSelectChange={(tags) => {
                        handleFilterTags(tags);
                      }}
                      onFilterUntagged={() => {
                        handleUntagged();
                      }}
                      removeTag={(tags, tag) => {
                        handleFilterTags(tags);
                      }}
                      mode={TagSelectorMode.Filter}
                      categoryId={0}
                      selectedTagIds={selectedTagIds}
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Grade Level</label>
                  <Select
                    isMulti={true}
                    className="mt-1 text-sm"
                    options={gradeLevelData}
                    onChange={(e) => {
                      handleFilterChange(e, "GradeLevel");
                    }}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>
                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Content Area</label>
                  <Select
                    options={contentAreas}
                    className="mt-1 text-sm"
                    isSearchable={true}
                    onChange={(e) => {
                      handleFilterChange(e, "ContentArea");
                    }}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="mt-4">
                <button
                  type="submit"
                  className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  onClick={() => bindVideos(false, false, true)}
                >
                  <FilterIcon className="w-3 h-3"></FilterIcon>
                  <span>Filter</span>
                </button>
                <button
                  type="button"
                  onClick={() => resetFilterHandler()}
                  className="py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <ResetIcon className="w-3 h-3"></ResetIcon>
                  <span>Reset Filter</span>
                </button>
              </div>
            </div>
            <div className="flex mt-4 items-center justify-end">
              <div className="flex space-x-4 items-center dark:text-white">
                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </div>
            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "videoId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("videoId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("videoId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Title
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "title" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("title")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("title")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                VideoUrl
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "contentArea" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("contentArea")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("contentArea")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Transcript
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "transcript" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("transcript")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("transcript")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                            >
                              <span className="flex">
                                Code
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "StandardCode" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("standardCode")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("standardCode")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                            >
                              <span className="flex">
                                Standard
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "StandardName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("standardName")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("standardName")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {videos.map((video, index) => (
                            <>
                              <tr
                                key={video.videoId}
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="px-3 py-2   whitespace-wrap text-sm text-left font-normal text-gray-500 relative cursor-pointer ">
                                  {video.isActive ? (
                                    <span className="mr-1 mt-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  ) : (
                                    <span className="mr-1 mt-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  )}
                                  <Link
                                    to={Constant.VIDEOEDIT.replace(
                                      ":id",
                                      video.videoId
                                        ? video.videoId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {video.videoId}
                                  </Link>
                                </td>
                                <td className="px-3 py-2   whitespace-wrap text-sm text-left font-normal text-gray-500">
                                  <Link
                                    to={Constant.VIDEOEDIT.replace(
                                      ":id",
                                      video.videoId
                                        ? video.videoId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {video.title}
                                  </Link>
                                </td>
                                <td className="px-3 py-2   whitespace-wrap text-sm text-left font-normal text-gray-500">
                                  <a
                                    rel="noreferrer"
                                    href={video.videoUrl}
                                    target="_blank"
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {video.videoUrl &&
                                      video.videoUrl !== "" &&
                                      video.videoUrl.split("/").at(-2) +
                                        "/" +
                                        video.videoUrl.split("/").at(-1)}
                                  </a>
                                </td>
                                <td className="px-3 py-2 whitespace-wrap text-sm textleft font-normal text-gray-500">
                                  {video?.transcript === null ? (
                                    video.transcript
                                  ) : (
                                    <Tooltip text={video.transcript} />
                                  )}
                                </td>
                                <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                  <Link
                                    to={Constant.EDITSTANDARD.replace(
                                      ":id",
                                      video.standardId
                                        ? video.standardId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {video.standardCode}
                                  </Link>
                                </td>
                                <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                  <Link
                                    to={Constant.EDITSTANDARD.replace(
                                      ":id",
                                      video.standardId
                                        ? video.standardId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {video.standardName}
                                  </Link>
                                </td>

                                <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal text-gray-700">
                                  <div className="flex gap-3 justify-center">
                                    {video.isApproved ? (
                                      <ApproveIcon title="Approved" />
                                    ) : (
                                      <Disapprove title="Unapproved" />
                                    )}
                                    <AllowedTo
                                      perform={Permissions.video_modify}
                                    >
                                      <EditIcon
                                        onClick={() => handleRedirect(video)}
                                        className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                      />
                                    </AllowedTo>
                                    <AllowedTo
                                      perform={Permissions.video_delete}
                                    >
                                      <DeleteIcon
                                        onClick={() =>
                                          confirmDelete(video.videoId)
                                        }
                                        className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                      />
                                    </AllowedTo>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                                  {video?.isActive ? (
                                    <span className="mr-1 mb-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  ) : (
                                    <span className="mr-1 mb-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  )}
                                </td>
                                <td colSpan={6}>
                                  {video?.videoTags?.map((tag) => (
                                    <li
                                      key={tag.tagId}
                                      className={`inline-block bg-[${
                                        tag.color
                                      }] 
                                rounded-full text-xs shadow-sm py-0.5 px-3  whitespace-nowrap mx-1 mb-2 cursor-pointer
                               ${
                                 TagColor.isDark(tag.color)
                                   ? "text-white"
                                   : "text-black"
                               }
                                `}
                                      onClick={() => {
                                        handleTagClick(tag);
                                      }}
                                    >
                                      {tag.name}
                                    </li>
                                  ))}
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    videos.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>
                {videos.length === 0 && <p className="p-2">No Records Found</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default Video;
